import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UtilitiesService } from "../helpers/utilities.service";
import { Observable } from 'rxjs';
import { Ad } from 'src/app/models/ad';

@Injectable({
  providedIn: 'root'
})
export class AdService {

  private headers = new HttpHeaders({
    'Accept': 'application/json'
  });

  constructor(
    private http: HttpClient,
    private utils: UtilitiesService) { }

  public getAds(): Observable<Array<Ad>>{
    return this.http.get<Array<Ad>>(this.utils.getAdApi(), { headers: this.headers });
  }
}
